// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--motion-duration-100:0.1s;--motion-ease-in-out:cubic-bezier(0.42,0,0.58,1)}`, "",{"version":3,"sources":["webpack://./../../packages/design-system/dist/tokens/transitions.css"],"names":[],"mappings":"AAAA,MAAM,0BAA0B,CAAC,gDAAgD","sourcesContent":[":root{--motion-duration-100:0.1s;--motion-ease-in-out:cubic-bezier(0.42,0,0.58,1)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
